module.exports = __webpack_public_path__ + "teambuilding.png?3de64570995b4fb92fea21e767d4c6dd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/teambuilding.png
// module id = 54
// module chunks = 0